import { store } from '@betacrew/jars-flux'
import { put, takeEvery, all, call, takeLatest } from 'redux-saga/effects';
import SignInDataService from '../../../services/SignInDataService';
import AuthenticationDataService from '../../../services/AuthenticationDataService';
import { componentKey, setAuthenticationLoader, setIsUserAuthenticated } from './AuthenticationSlice';
import { setSignedInUser } from './AuthenticationSlice';
import { PAGE_STATE } from '../constants/constants';
import { setIsPrepayAmountFetched } from '../loaders/dataloader/DataLoaderSlice';

export const { logoutUser, checkUserIsAuthenticated } = {
    logoutUser: (payload) => {
        return {
            type: "AUTHENTICATION/LOGOUT",
            payload: payload
        }
    },
    checkUserIsAuthenticated: (payload) => {
        return {
            type: "AUTHENTICATION/CHECK",
            payload: payload
        }
    }
}

function* logoutUserAsync() {
    try {
        const response = yield SignInDataService.logoutUser();
        yield put(setIsUserAuthenticated(false));
        yield put(setIsPrepayAmountFetched(false));
        yield put(setSignedInUser({}));
    } catch (error) {
        console.log(error);
    }
}
function* checkUserIsAuthenticatedAsync() {
    try {
        yield put(setAuthenticationLoader({ state: PAGE_STATE.LOADING }))
        const response = yield AuthenticationDataService.checkIsAuthenticated();
        if (response?.data?.Status && response.data.Status == 1) {
            yield put(setIsUserAuthenticated(true));
        } else {
            yield put(setIsUserAuthenticated(false));
        }
    } catch (error) {
        console.log(error);
        yield put(setIsUserAuthenticated(false));
    } finally {
        yield put(setAuthenticationLoader({ state: PAGE_STATE.PAGE_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(logoutUser().type, logoutUserAsync),
        takeLatest(checkUserIsAuthenticated().type, checkUserIsAuthenticatedAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);